import { IContact } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { getSeparatedPhone } from 'legacy/lut/components/widgets/public/phoneEditor/helpers/getSeparatedPhone'

export const getContactPhone = (contact: IContact) => {
  return getSeparatedPhone({
    phone: contact.MainPhoneNorm || contact.WorkPhoneNorm || contact.MobilePhoneNorm || '',
  })
}
